<template>
    <v-footer app>
        <v-col cols="12" class="text-center pa-0">
            Powered by <a href="https://institut.digital" target="_blank"> institut.digital</a>
        </v-col>
    </v-footer>
</template>

<script>
    export default {
        name: "app-layout-footer"
    }
</script>

<style scoped>

</style>